import { useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function usePatientAppLogin() {
  const login = useCallback(
    (credentials) => quarkusApi.post('/patient-app/login', credentials),
    [],
  );

  return { login };
}
